import React, { Component } from "react";
import ContentLoader from "react-content-loader";
import "./shimmer.scss";

function GeneralContentLoader() {
  return (
    <div className="col-xs-12 col-md-6 shimmer">
      <img src="" alt="" aria-hidden="true" className="placeholder placeholder-general" />
      <ContentLoader height={100} speed={2} className="shimmer-element shimmer-content">
        <rect x="15" y="15" rx="3" ry="3" width="32" height="32" />
        <rect x="62" y="20" rx="3" ry="3" width="323" height="20" />
        <rect x="62" y="50" rx="3" ry="3" width="323" height="8" />
        <rect x="62" y="63" rx="3" ry="3" width="323" height="8" />
        <rect x="285" y="76" rx="3" ry="3" width="30" height="12" />
        <rect x="320" y="76" rx="3" ry="3" width="30" height="12" />
        <rect x="355" y="76" rx="3" ry="3" width="30" height="12" />
      </ContentLoader>
    </div>
  );
}

class GeneralContentShimmer extends Component {
  render() {
    return (
      <>
        <GeneralContentLoader />
        <GeneralContentLoader />
        <GeneralContentLoader />
        <GeneralContentLoader />
      </>
    );
  }
}

export default GeneralContentShimmer;
